import React, { useState, useEffect } from "react";
import { Modal, Form, InputNumber, Input, message } from "antd";
import { changeRegistrationFee } from "../api/subscriptions/subscriptionsRequest";

const { TextArea } = Input;

const ChangeRegistrationFeeModal = ({
  visible,
  onCancel,
  onSuccess,
  subscription,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && subscription) {
      form.setFieldsValue({
        new_registration_fee: subscription.registration_fee,
        reason: "",
      });
    }
  }, [visible, subscription, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await changeRegistrationFee(subscription.id, values);

      if (response.success) {
        message.success(
          response.message || "Frais d'inscription mis à jour avec succès"
        );
        form.resetFields();
        onSuccess();
      } else if (response.message === "No change detected") {
        message.info("Aucun changement détecté");
        onCancel();
      } else {
        message.error(response.error || "Erreur lors de la mise à jour");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        "Erreur lors de la mise à jour des frais d'inscription";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Modifier les frais d'inscription"
      open={visible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      okText="Enregistrer"
      cancelText="Annuler"
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          new_registration_fee: 0,
          reason: "",
        }}
      >
        <Form.Item
          label="Nouveaux frais d'inscription"
          name="new_registration_fee"
          rules={[
            { required: true, message: "Les frais d'inscription sont requis" },
            {
              type: "number",
              min: 0,
              message: "Les frais doivent être positifs ou nuls",
            },
          ]}
        >
          <InputNumber
            style={{ width: "100%" }}
            placeholder="Entrer les nouveaux frais"
            min={0}
            step={0.01}
            precision={2}
          />
        </Form.Item>

        <Form.Item
          label="Raison de la modification"
          name="reason"
          rules={[
            {
              max: 1000,
              message: "La raison ne peut pas dépasser 1000 caractères",
            },
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Expliquer la raison de cette modification des frais..."
          />
        </Form.Item>
      </Form>

      {subscription && (
        <div
          style={{
            marginTop: 16,
            padding: 12,
            backgroundColor: "#f5f5f5",
            borderRadius: 4,
          }}
        >
          <strong>Informations actuelles :</strong>
          <div>Référence abonnement: {subscription.contract_number}</div>
          <div>
            Frais d'inscription actuels: {subscription.registration_fee} MAD
          </div>
          <div>Type d'abonnement: {subscription.subscription_type?.name}</div>
        </div>
      )}
    </Modal>
  );
};

export default ChangeRegistrationFeeModal;
